import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Icon, Tooltip, Divider } from '@sendgrid/ui-components';
import Styles from './summarytable.module.scss';
import withPackages from '../containers/withPackages';
import withAddOns from '../containers/withAddOns';
import PackageRow from './PackageRow';
import ExtraEmailsRow from './ExtraEmailsRow';
import ContactsRow from './ContactsRow';
import AddonRow from './AddonRow';
import TotalRow from './TotalRow';
import dollarize, { calculateEstimatedEmailPrice, calculateEstimatedContactsPrice, calculateEasePrice } from '../utils/displayHelpers';
import { getEstimatedFromPricing } from '../utils/cookieHelpers';
import { ADDONS } from '../constants';

const SummaryTable = (props) => {
  const isPro = props.packages.activePackage.plan_type === 'pro';
  const emails = getEstimatedFromPricing('totalEmails');
  const contacts = getEstimatedFromPricing('contacts');
  const extraEmails =
    emails && props.packages.activePackage.credits && !props.packages.activeIsFree ?
      emails.num - props.packages.activePackage.credits :
      0;
  const emailsPrice = emails ?
    calculateEstimatedEmailPrice(emails.num, props.packages.activePackage) :
    0;
  const contactsPrice =
    contacts && !props.packages.activeIsFree ? calculateEstimatedContactsPrice(contacts.num) : 0;
  const addOnsPrice =
  (isPro ? props.addOns[ADDONS.DEDICATED_IP] * ADDONS.IP_COST : 0)
  + (!props.packages.activeIsFree ?
    calculateEasePrice(props.addOns[ADDONS.EASE], props.packages.activePackage.name) : 0);
  const totalPrice =
    addOnsPrice + props.packages.activePackage.base_price + emailsPrice + contactsPrice;
  return (
    <Fragment>
      <section className={Styles.summarywrapper}>
        <h2>{props.title}&nbsp;
          <Tooltip content={props.tooltipcontent} direction="down">
            <Icon type="info-circle" />
          </Tooltip>
        </h2>
        <table className={Styles.summarytable}>
          <tbody className={Styles.servicerow}>
            <PackageRow
              name={props.packages.activePackage.name}
              price={props.packages.activePackage.base_price}
            />
            { extraEmails > 0 ?
              <ExtraEmailsRow
                name="extra emails (Estimated)"
                extraEmails={extraEmails}
                price={dollarize(emailsPrice)}
              /> :
              null
            }
            { contacts && !props.packages.activeIsFree ?
              <ContactsRow
                name="contacts (Estimated)"
                contacts={contacts.num}
                price={dollarize(contactsPrice)}
              /> :
            null
          }
            { isPro ?
              <AddonRow type="ip" /> :
            null
          }
            { !props.packages.activeIsFree ? <AddonRow type="ease" package={`${props.packages.activePackage.name}`} /> : null}
            <tr>
              <td colSpan="2">
                <Divider thin />
              </td>
            </tr>
            <TotalRow isLarge total={totalPrice} label={`Estimated monthly cost${props.packages.activeIsFree ? '' : '*'}`} />
          </tbody>
        </table>
      </section>
    </Fragment>
  );
};

SummaryTable.propTypes = {
  packages: PropTypes.shape({
    activePackage: PropTypes.object.isRequired,
    activeIsFree: PropTypes.bool.isRequired,
  }).isRequired,
  title: PropTypes.string.isRequired,
  tooltipcontent: PropTypes.string.isRequired,
  addOns: PropTypes.shape({
    [ADDONS.DEDICATED_IP]: PropTypes.number.isRequired,
  }).isRequired,
};

export default withRouter(withPackages(withAddOns(SummaryTable)));



// WEBPACK FOOTER //
// ./src/components/SummaryTable.jsx